import { createContext } from 'react';
import { scaleIcon, collabIcon, affordableIcon, readyIcon } from '../assets';

export const CopyContext = createContext();

function MyProvider({ children }) {
    
    // Hero Section

    const heroPage = {
        video: "https://truerep.retool.com/api/file/6e885d07-b297-4494-85cd-bdf257539735",
    };

    // About Section

    const aboutCards = [
        {
            title: "Ready for scale",
            description: "Your relationship data is precious. Keep it organized, clean, and trackable as you grow.",
            img: scaleIcon,
        },
        {
            title: "Collaborative & open",
            description: "Working with a partner who isn't a TrueRep customer? No problem. We make sure you can get the data you need quickly and give them that option, too.",
            img: collabIcon,
        },
        {
            title: "Affordable",
            description: "TrueRep is focused on providing what you need to handle your creator program and nothing more. We’re priced accordingly and will scale manageably with you.",
            img: affordableIcon,
        },
        {
            title: "Ready to go on day 1",
            description: "Whether you're just starting out or looking for a quickly deployable upgrade from Google Sheets, we have the infrastructure and features you need to do your job better and with less headaches.",
            img: readyIcon,
        }
    ];

    // Features Section

    const featureCards = [
        {
          title: "Reporting and listening for what you need",
          description: "TrueRep will help you track your pipeline, keep tabs on up-and-coming creators, and ping you exactly when that VIP integration gets published.",
          category: ["AGENTS", "BRANDS"],
          imgUrl: "https://truerep.retool.com/api/file/fabb617a-da16-460a-9a16-dda8540a52e9",
        },
        {
          title: "Generate custom pitches",
          description: "Get started with just the channel links or saved talent rosters and we'll generate a unique link you can share with brands.",
          category: ["AGENTS"],
          imgUrl: "https://app.truerep.io/api/file/6ad21aea-9ddc-471c-b972-32aeb8668d8d",
        },
        {
          title: "Don't sweat the data",
          description: "When you send a pitch to a brand, they'll get exactly the data they need, even if they don't have TrueRep. Forget wasting time on data collection.",
          icon: "",
          category: ["AGENTS"],
          imgUrl: "https://app.truerep.io/api/file/5bc29be5-09a7-4c63-8f05-155eca1ae1ad",
        },
        {
          title: "One single inbound stream",
          description: "Ditch the infinite Google Sheets and get all your offers into one pipeline with all the metrics and history you need to assess each opportunity.",
          category: ["BRANDS"],
          imgUrl: "https://app.truerep.io/api/file/9243f948-c3db-4fd0-810c-1e669abca5c3",
        },
        {
          title: "Get to decisions, fast",
          description: "Saved pricing models help you get from channel link to decision in a matter of seconds.",
          category: ["BRANDS"],
          imgUrl: "https://app.truerep.io/api/file/42eab539-bdbe-4f18-8c10-3176d6c6e26b",
        },
      ];

    // FAQ Section

    const faqs = [
        {
            id: 1,
            ques: "What is TrueRep?",
            ans: "TrueRep is a software platform built for businesses that are working with creators that allows them to track and analyze their contacts, offers, and campaigns."
        },
        {
            id: 2,
            ques: "What social platforms does it work for?",
            ans: "Currently TrueRep only supports creators and campaigns run on YouTube."
        },
        {
            id: 3,
            ques: "How much does it cost?",
            ans: "Since TrueRep is in its alpha stage, pricing will vary based on each business' needs.  We feel very confident we can match or beat the price of other influencer solutions out there, so let's talk about it."
        },
        {
            id: 4,
            ques: `You talk about "agents" a lot.  What does that mean?`,
            ans: `When we say "agents", we're talking about people or business entities that are transacting in a partnership on behalf of a "seller" (i.e., a creator selling invetory) or a "buyer" (i.e., a brand or company buying that invetory). \nBy this definition, in the creator marketplace, agents can refer to advertising agencies, media buyers, talent agents, and managers.`
        },
    ];

    return (
        <CopyContext.Provider
            value={({
                heroPage: heroPage, 
                aboutCards: aboutCards, 
                featureCards: featureCards, 
                faqs: faqs
            })}>
            
            {children}
        </CopyContext.Provider>
    )
};

export default MyProvider;